<template>
  <div>
    <change-account-password v-model="passwordSetting" />
    <div class="sub-header">
      <div class="header d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <i class="mr-2 header-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
                fill="#353535" />
            </svg>
          </i>
          <h1 class="xxl">
            {{ resource["profile.HeaderText"] }}
          </h1>
        </div>
      </div>
    </div>
    <div class="page-view">
      <div class="container my-account p-0">
        <div class="c-column-01">
          <div class="c-container-01">{{ getProfileContent }}</div>
          <div class="c-container-02">
            <div class="c-item-01">{{ currentUser.name }} {{ currentUser.surname }} </div>
            <div class="c-item-02">{{ currentUser.email }} </div>
          </div>
        </div>
        <hr />
        <div class="c-column-02">
          <div class="c-container-01">
            <div class="c-item-01">{{ resource['hrvenue.createCandidate.Email'] }}</div>
            <div class="c-item-02">{{ currentUser.email }} </div>
          </div>
          <div class="c-container-01">
            <div class="c-item-01">{{ resource['profile.PasswordLabel'] }}</div>
            <div class="c-item-02">
              <span class="password-field">******</span> <span class="change-pass-btn cursor-pointer text-color-purple"   @click="changePassword()">{{ resource['label.Change']}} ></span>
            </div>
          </div>
          <div class="c-container-01">
            <div class="c-item-01">{{ resource['profile.lastLoginDateLabel'] }}</div>
            <div class="c-item-02">{{ globalFormatTimeUserLocal(currentUser.lastLoginDate, "DD MMMM YYYY / hh:mm") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyAccount',
  data() {
    return {
      passwordSetting: false,
    };
  },
  components: {
    ChangeAccountPassword: () => import('../management/ChangeAccountPassword.vue'),
  },
  // created () {
  //   return console.log('this.current', this.currentUser);
  // },

  computed: {
    getProfileContent() {
      return (
        this.currentUser.name[0] + this.currentUser.surname[0]
      ).toUpperCase();
    },
  },
  methods: {
    changePassword() {
      this.passwordSetting = true;
    },
  },
};
</script>

<style lang="scss">
.my-account {
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  background: #fff;
  padding: 0;
}

hr {
  width: 50%;
  height: 1px;
  background: #E4E4E4;
  margin: 0;
  border: 0;
}

.c-column-01,
.c-column-02 {
  padding: 20px 16px;
}

.c-column-01 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .c-container-01 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    background: #353535;
    border-radius: 50%;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #FFFFFF;
    margin-right: 16px;
  }

  .c-container-02 {
    .c-item-01 {
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      color: #353535;
      margin-bottom: 4px;
    }

    .c-item-02 {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #353535;

    }
  }
}

.c-column-02 {
  .c-container-01 {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .c-item-01 {
      width: 150px;
      margin-right: 30x;
      font-weight: 700;
      font-size: 12px;
      line-height: 18px;
      color: #353535;
    }

    .c-item-02 {
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #353535;
      display: flex;
      align-items: center;
      .change-pass-btn{
        font-weight: 700;
        color: #FF8D06;
        margin-left: 8px;
      }
    }
  }

  >:last-child {
    margin-bottom: 0;
  }
}
</style>
